var map = {
	"./death_knight_blood.jpg": 6048,
	"./death_knight_frost.jpg": 7970,
	"./death_knight_unholy.jpg": 8053,
	"./druid_balance.jpg": 9762,
	"./druid_feral_combat.jpg": 839,
	"./druid_restoration.jpg": 4046,
	"./hunter_beast_mastery.jpg": 8767,
	"./hunter_marksmanship.jpg": 498,
	"./hunter_survival.jpg": 2956,
	"./mage_arcane.jpg": 5664,
	"./mage_fire.jpg": 4734,
	"./mage_frost.jpg": 6814,
	"./paladin_holy.jpg": 421,
	"./paladin_protection.jpg": 7954,
	"./paladin_retribution.jpg": 3392,
	"./priest_discipline.jpg": 5869,
	"./priest_holy.jpg": 2245,
	"./priest_shadow.jpg": 6547,
	"./rogue_assassination.jpg": 9394,
	"./rogue_combat.jpg": 6894,
	"./rogue_subtlety.jpg": 8592,
	"./shaman_elemental.jpg": 3715,
	"./shaman_enhancement.jpg": 7046,
	"./shaman_restoration.jpg": 9084,
	"./warlock_affliction.jpg": 8816,
	"./warlock_demonology.jpg": 670,
	"./warlock_destruction.jpg": 7801,
	"./warrior_arms.jpg": 795,
	"./warrior_fury.jpg": 3410,
	"./warrior_protection.jpg": 2287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6807;